"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var footer_constants_exports = {};
__export(footer_constants_exports, {
  links: () => links
});
module.exports = __toCommonJS(footer_constants_exports);
var links = [{
  href: "https://greatminds.org/privacy-policy",
  text: "dp_core_footer_privacyPolicy",
  dataDpAnalyticsId: "GlobalElementsGlobalFooterPrivacyLink"
}, {
  href: "https://greatminds.org/legal/terms-of-service",
  text: "dp_core_footer_termsOfService",
  dataDpAnalyticsId: "GlobalElementsGlobalFooterTermsOfServiceLink"
}, {
  href: "https://legal.greatminds.org",
  text: "base_glossary_credits",
  dataDpAnalyticsId: "GlobalElementsGlobalFooterCreditsLink"
}, {
  href: "https://digitalsupport.greatminds.org/s/",
  text: "base_glossary_helpCenter",
  dataDpAnalyticsId: "GlobalElementsGlobalFooterHelpCenterLink"
}, {
  href: "https://greatminds.org/privacy-options",
  text: "dp_core_footer_caResidentsNote",
  dataDpAnalyticsId: "GlobalElementsGlobalFooterCAResidentsLink"
}];
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  links
});
//# sourceMappingURL=footer.constants.js.map